// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.template-QsIUVW{margin-bottom:0}.template-QsIUVW .template-wrapper-ogPHKn{position:relative}.template-QsIUVW .btn-container-vkmxIx{width:100%;display:none;position:absolute;bottom:0;left:0}.template-QsIUVW:hover .btn-container-vkmxIx{display:block}.template-QsIUVW:hover .description-WS94RD{visibility:hidden}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"template": `template-QsIUVW`,
	"template-wrapper": `template-wrapper-ogPHKn`,
	"templateWrapper": `template-wrapper-ogPHKn`,
	"btn-container": `btn-container-vkmxIx`,
	"btnContainer": `btn-container-vkmxIx`,
	"description": `description-WS94RD`
};
export default ___CSS_LOADER_EXPORT___;
